<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="500px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <el-form :model="addForm" size="small" :rules="rules" ref="addForm" label-width="110px" v-loading="loading">
        <el-form-item label="开始时间:" prop="startDate">
          <el-date-picker v-model="addForm.startDate" value-format="yyyyMMdd" size="small" type="date" style="width: 150px" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发货周期:" prop="deliveryCycle">
          <el-input size="small" v-model="addForm.deliveryCycle" />
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="onCancel" size="small">取消</el-button>
        <el-button type="primary" @click="onConfirm" size="small" :loading="loadingButtom">确定</el-button>
        <el-button type="success" @click="handleNotifyOpen" size="small" :loading="loadingButtom" v-permission="'ec-pc-new#informationManagement#noticeBtn'">确定并通知店铺</el-button>
      </div>
    </q-dialog>
    <!-- 上传通知店铺 -->
    <notify-store-dialog :visible.sync="showNotifyDialog" v-if="showNotifyDialog" @confirm="handleNotifyConfirm" />
  </div>
</template>

<script>
import notifyStoreDialog from '@/components/notify-store-dialog/notify-store-dialog';
export default {
  components: { notifyStoreDialog },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    formData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '后端发货周期批量维护';
    },
  },
  data() {
    return {
      addForm: {
        aclasses: [],
        startDate: '',
      },
      rules: {
        startDate: [{ required: true, message: '不能为空！', trigger: 'change' }],
        deliveryCycle: [
          { required: true, message: '不能为空！', trigger: 'bulr' },
          { pattern: /^(?:1000|[1-9]\d{0,2}|0)$/, message: '请输入0-1000的正整数!' },
        ],
      },
      loading: false,
      loadingButtom: false,
      showNotifyDialog: false,
      isNotify: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        let { goodsCode } = this.formData || {};
        this.loadingButtom = true;
        let data = {
          ...this.addForm,
          goodsCodeList: goodsCode ? goodsCode.split(' ') : [],
        };
        this.$q.goods
          .baseAttrBatchEdit({ data: data })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success('调整成功');
              this.isVisible = false;
              this.$emit('success');
              if (this.isNotify) {
                this.notifyStore();
              }else {
                let notiyData = {
                  adjustContent: '发货周期',
                  isImport: 0,
                  operType: '不通知'
                }
                this.notificationLog(notiyData)
              }
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    init() {
      let { goodsCode } = this.formData || {};
      this.loading = true;
      let data = {
        exportTag: false,
        filterData: {
          goodsCode: '',
          goodsCodeList: goodsCode ? goodsCode.split(' ') : [],
        },
        pageNum: 1,
        pageSize: 999999,
      };
      this.$q.goods
        .baseAttrManager({ data })
        .then((res) => {
          if (res.code == 200 && res.data.records) {
            this.deliveryCycleList = res.data.records || [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleNotifyOpen() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.showNotifyDialog = true;
        this.isNotify = false;
      });
    },
    handleNotifyConfirm(data) {
      this.isNotify = true;
      this.notifyForm = data;
      this.onConfirm()
    },
    notifyStore() {
      this.isNotify = false;
      let itemAOList = this.deliveryCycleList.map((v) => {
        return {
          skuCode: v.goodsCode,
          adjustBefore: v.deliveryCycle,
          adjustAfter: this.addForm.deliveryCycle,
        };
      });
      let data = {
        ...this.notifyForm,
        adjustContent: '发货周期',
        itemAOList: itemAOList,
        isImport: 0,
        operType: '通知'
      };
      this.notificationLog(data)
      this.$q.goods.saveMsgNotice({ data: data }).then((res) => {
        if (res.success) {
          if (this.notifyForm.noticeTime == 0) {
            this.$store.dispatch('menu/getMenusNum', {}, { root: true });
          }
        }
      });
    },
    notificationLog(data) {
      this.$q.goods.msgNoticeSaveLog({ data: data })
    }
  },
};
</script>

<style lang="stylus" scoped>

.footer {
  text-align: center;
  padding: 15px;
}

>>> .el-form-item {
  margin-bottom: 22px !important;
}

>>> .el-select, >>> .el-date-editor, >>> .el-input {
  width: 150px !important;
}
</style>
